const quotesText = [
  {
    heading: "Daily quote",
  },
  {
    heading: "Dienos citata",
  },
  {
    heading: "Cytata dnia",
  },
];

export default quotesText;
